module.exports = __webpack_public_path__ + "static/img/dongshizhang05@2x.2d17788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/dongshizhang05@2x.png
// module id = 9xFa
// module chunks = 0